<template>
  <div style="width:100%;height: 100%;overflow:auto;">
    <div style="display: flex;margin-left: 10px;margin-top: 10px;position: relative;">
      <el-select v-model="year" style="width: 150px;" @change="initData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label + '年度'" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="area" style="width: 150px;margin-left: 10px;" @change="initData">
        <el-option v-for="area in areaList" :key="area.code" :label="area.name" :value="area.code"></el-option>
      </el-select>
      <div style="display: flex;position: absolute;top: 0;right: 10px;">
        <div style="width:300px;margin-right: 10px;text-align: right;line-height: 30px;">数据创建日期：</div>
        <el-input v-model="dataCreateDate" style="width:200px;margin-right: 10px;" disabled></el-input>
      </div>
    </div>

    <div style="margin-left: 10px;margin-top: 10px;font-size: 18px"><b>1.Bookings($)：</b></div>
    <div style="width: 98%;height: 300px;" id="bookingChart"></div>

    <div style="margin-top: 10px;" v-for="(item,index) in agentKpiList" >
      <div style="margin-left: 10px;margin-top: 10px;font-size: 18px"><b>{{ index + 2 }}.{{item.name}}：</b></div>
    <div style="width: 98%;height: 300px;" :id="'agentChart-'+index"></div>
    </div>




  </div>
</template>


<script>

import * as echarts from "echarts";
import dayjs from "dayjs";
export default {
  name: "RegionalRanking",

  data(){
    return{
      year:'',
      yearList:[],
      area:'',
      areaList:[],
      dataCreateDate:'',
      bookingSeriesData:[],
      otherSeriesData: {},
      yAxisData:[],

    }
  },
  computed: {
    agentKpiList() {
      return this.$store.getters['core/getDictList']('kpi_agent_kpi_name');
    },
  },
  async created() {
    await this.getYearList();
    await this.getAreaList();
    await this.initData();

  },

  methods:{

    async initData(){
      await this.getRegionalRankingData();
      await this.renderEcharts();

      for (let item of this.agentKpiList){
        let index = this.agentKpiList.indexOf(item);
        let data = this.otherSeriesData[item.value];
        await this.renderOtherEcharts(data,index);
      }

    },

    async getRegionalRankingData(){
      let params = {year:this.year,area:this.area}
      let data = await this.$http('crmAgentService.getRegionalRankingData',params);
      this.dataCreateDate = data?.dataCreateDate;
      this.yAxisData = data?.yAxisData;
      this.bookingSeriesData = data?.bookingSeriesData;
      this.otherSeriesData = data?.otherSeriesData;
    },

    async getYearList(){
      const now = dayjs();
      this.year = now.year() + '';
      this.yearList = await this.$http('sysDsService.getYears(10,1)')
    },

    async getAreaList(){
      this.areaList = await this.$http('crmAgentService.getAreaList');
      if(this.areaList.length > 0){
        this.areaList.push({code:'all',name:'全国'})
        this.area = this.areaList[0].code;
      }
    },

    renderEcharts(){
      const bookingChartDom = document.getElementById('bookingChart');
      // 获取现有的 ECharts 实例（如果有）
      let bookingChart = echarts.getInstanceByDom(bookingChartDom);
      // 如果存在现有的实例，销毁它
      if (bookingChart) {
        bookingChart.dispose();
      }
      // 初始化新的 ECharts 实例
      bookingChart = echarts.init(bookingChartDom);
      bookingChart.setOption(this.getBookingChartOptions(), true);
    },
    getBookingChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        yAxis: {
          type: 'category',
          data: this.yAxisData === undefined ? [] : this.yAxisData,
        },
        xAxis: {
          type: 'value'
        },
        series: this.bookingSeriesData === undefined ? [] : this.bookingSeriesData
      }
    },
    renderOtherEcharts(data,index){
      const bookingChartDom = document.getElementById('agentChart-'+index);
      // 获取现有的 ECharts 实例（如果有）
      let bookingChart = echarts.getInstanceByDom(bookingChartDom);
      // 如果存在现有的实例，销毁它
      if (bookingChart) {
        bookingChart.dispose();
      }
      // 初始化新的 ECharts 实例
      bookingChart = echarts.init(bookingChartDom);
      bookingChart.setOption(this.getOtherChartOptions(data), true);
    },
    getOtherChartOptions(data){
      return{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        yAxis: {
          type: 'category',
          data: this.yAxisData === undefined ? [] : this.yAxisData,
        },
        xAxis: {
          type: 'value'
        },
        series: data === undefined ? [] : data,
      }
    }
  }
}
</script>

<style scoped>

</style>